<nav class="border-common-base flex h-full flex-col border-x">
  <div
    class="text-common-base border-common-base flex h-[3.5rem] w-full shrink-0 items-center gap-2 border-y p-4"
  >
    <svg-icon src="assets/icons/general/calendar.svg" />
    <span class="font-semibold">{{ isoWeekService.currentWeek }}</span>
  </div>

  <ul class="flex w-full grow flex-col gap-2 overflow-auto p-2">
    @for (nav of navService.getMainNavigation(); track nav) {
      @if (nav?.items) {
        <ng-container *agHasPermissionAny="nav.permissions">
          <li>
            <app-navigation-item [navList]="nav" />

            @if (navService.isSelectedList(nav.label)) {
              <ul class="my-2 !ml-8 flex flex-col">
                @for (navItem of nav?.items; track navItem) {
                  <ng-container *agHasPermission="navItem.permission">
                    <li>
                      <app-navigation-item
                        [navItem]="navItem"
                        [isNested]="true"
                      />
                    </li>
                  </ng-container>
                }
              </ul>
            }
          </li>
        </ng-container>
      }
      @if (!nav.items) {
        <ng-container *agHasPermission="nav.permission">
          <li>
            <app-navigation-item [navItem]="nav" [isNested]="false" />
          </li>
        </ng-container>
      }
    }
  </ul>

  <div class="mt-auto grid shrink-0 place-items-center border-t px-2 py-4">
    <svg-icon src="assets/icons/brand/logo-horizontal-primary-default.svg" />
  </div>
</nav>
